import React from "react";
import { Divider, Tag, Timeline, TimelineItemProps, Typography } from "antd";
import { ResumeEducation as ResumeEducationType } from "../../Entities/UserProfile";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

const formatMonthYear = (dateString: string | null | undefined): string => {
  if (!dateString || dateString.trim() === "") return "";
  const parsed = dayjs(dateString);
  if (!parsed.isValid()) return "";
  return parsed.format("MMM YYYY");
};

const EducationItem: React.FC<{
  degree: string | null;
  school: string | null;
  description: string | null;
  location: string | null;
  from: Date | string | null;
  to: Date | string | null;
}> = ({ school, description, degree, location, from, to }) => {
  const getTagText = () => {
    if (!from && !to) {
      return null;
    } else if (from) {
      if (!to) {
        return `${formatMonthYear(from.toString())} - Present`;
      } else {
        return `${formatMonthYear(from.toString())} - ${formatMonthYear(to.toString())}`;
      }
    } else {
      return null;
    }
  };

  const tagText = getTagText();

  return (
    <div className="experience-item">
      <div className="experience-item-header">
        <div className="experience-item-header-title">
          <Typography.Text strong>
            {degree ? degree : "Degree NA"}
          </Typography.Text>

          <Typography.Text
            style={{ display: "flex", alignItems: "center", gap: "4px" }}
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "14px" }}
            >
              domain
            </span>
            {school ? school : "School NA"}
          </Typography.Text>
          <Typography.Text
            style={{ display: "flex", alignItems: "center", gap: "4px" }}
          >
            <span
              className="material-symbols-outlined"
              style={{ fontSize: "14px" }}
            >
              location_on
            </span>
            {location ? location : "Location NA"}
          </Typography.Text>
        </div>
        <Tag>{tagText ? tagText : "NA"}</Tag>
      </div>
      <Typography.Paragraph
        type="secondary"
        style={{ fontSize: "13px", fontStyle: "italic", margin: 0 }}
      >
        {description ? description : "No description available on the resume"}
      </Typography.Paragraph>
    </div>
  );
};

interface ResumeEducationProps {
  educations: ResumeEducationType[];
}

const ResumeEducation: React.FC<ResumeEducationProps> = ({ educations }) => {
  const items: TimelineItemProps[] = educations.map((e, i) => {
    return {
      key: i,
      children: (
        <EducationItem
          key={i}
          degree={e.degree || null}
          school={e.school || null}
          description={e.description || null}
          location={e.location || null}
          from={e.from || null}
          to={e?.to || null}
        />
      ),
    };
  });
  return (
    <div className="resume-preview-card">
      <div className="resume-preview-card-header">
        <div className="resume-preview-card-header-title">
          <span className="material-symbols-outlined" style={{ margin: 0 }}>
            school
          </span>
          <Typography.Title level={5} style={{ margin: 0 }}>
            Education
          </Typography.Title>
        </div>
      </div>
      <Divider style={{ margin: 0 }} />
      <Timeline items={items} style={{ width: "100%" }} />
    </div>
  );
};

export default ResumeEducation;
